export default __webpack_public_path__ + "static/media/win_five.82ee9932.svg";